export enum CookieType {
	CustomerName = 'customerName',
	CustomerInfo = 'customerInfo',
	RedirectUrl = 'redirectUrl',
	KycRenewal = 'timeToRenew',
	LoanInfo = 'loanInfo',
	DepositCustomer = 'DepositCustomer',
	Sbl = 'sbl',
	ApplicationQuery = 'applicationQuery',
	LoanCustomer = 'LoanCustomer',
	DepositCustomerInfo = 'depositCustomerInfo',
}
